import React, { useState } from "react";
import { Modal } from "react-bootstrap";
import "./modalBox.css";
import { Activity, currentRequestTimeStamp } from "../../Constants";

const PopupWidget = ({
  onClose = "",
  buttonLabel = "",
  modalTitle = "",
  content = "",
  buttonID = "",
  headerClassName = "h4",
  disabled,
  activityname = "",
  modalClassName = "modalBox",
  buttonclassName = "",
  screen = "",
  size = "md",
  modulename = "",
  isAlertDialog = false,
  closeButtonId = "close_contactus",
  modalBodyStyle = {},
  pulse = false,
  buttonStyles = {},
  title = ""
}) => {
  const [lgShow, setLgShow] = useState(false);

  const closeModal = () => {
    if (onClose) onClose();
    setLgShow(false);
  };

  const ClickModal = () => {
    Activity([
      {
        screen: screen,
        module: modulename,
        activity: activityname,
        timestamp: currentRequestTimeStamp(),
      },
    ]);
    setLgShow(!lgShow);
  };

  return (
    <>
      <button
        className={buttonclassName}
        onClick={(e) => ClickModal()}
        disabled={disabled}
        id={buttonID ? buttonID : ""}
        style={buttonStyles}
        title={title}
      >
        {pulse ? (
          <>
            <span
              className="spinner-grow spinner-grow-sm mr-1"
              role="status"
              aria-hidden="true"
            ></span>
            <span className="sr-only">Loading...</span>
          </>
        ) : null}

        {buttonLabel}
      </button>
      <Modal
        id={buttonID ? buttonID : ""}
        size={size}
        show={lgShow}
        onHide={() => setLgShow(false)}
        aria-labelledby="example-modal-sizes-title-lg"
        backdrop="static"
        className={modalClassName}
      >
        {isAlertDialog && <div id="close_contactus" onClick={closeModal}></div>}
        {!isAlertDialog && (
          <Modal.Header>
            <Modal.Title
              className={`${headerClassName}`}
              id="example-modal-sizes-title-lg"
            >
              {modalTitle}
            </Modal.Title>
            <button
              id={closeButtonId ? closeButtonId : "close_contactus"}
              type="button"
              className="btn btn-secondary"
              onClick={(e) => closeModal()}
            >
              <i className="fa fa-times"></i>
            </button>
          </Modal.Header>
        )}

        <Modal.Body style={{ ...modalBodyStyle }}>{content}</Modal.Body>
      </Modal>
    </>
  );
};

export default PopupWidget;
